import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    clearAuthError,
    getAuthModalClosingPossibility,
    getAuthModalState,
    getRegisterStepCount,
    toggleAuthModal
} from '../../../store/slices/authSlice';
import Modal from '../../common/Modal';
import FirstAuthStep from './FirstAuthStep';
import SecondAuthStep from './SecondAuthStep';

const stepsConfig = [FirstAuthStep, SecondAuthStep];

const AuthModal = () => {
    const dispatch = useDispatch();
    const isShow = useSelector(getAuthModalState);
    const registerStep = useSelector(getRegisterStepCount);
    const isCanBeClosed = useSelector(getAuthModalClosingPossibility);

    const Form = useMemo(() => {
        return stepsConfig[registerStep - 1];
    }, [registerStep]);

    const onBtnClose = () => {
        dispatch(toggleAuthModal({ trigger: false, step: registerStep }));
    };

    useEffect(() => {
        dispatch(clearAuthError());
    }, []);

    return isShow ? <Modal children={<Form />} withCrossBtn={true} onCloseClick={isCanBeClosed ? onBtnClose : null} /> : null;
};

export default AuthModal;
